import React from 'react'
import {
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { post } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const AddBalance = (props) => {
  const { handleClose, setAddBalanceModal } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    credits_requested: '',
  })
  const [customBalanceInput, setCustomBalanceInput] = React.useState(false)
  const [customBalance, setCustomBalance] = React.useState({
    credits_requested: '',
  })
  const balanceOptions = [
    { label: 'Select Option*', value: '' },
    { label: '10,000', value: '10000' },
    { label: '25,000', value: '25000' },
    { label: '50,000', value: '50000' },
    { label: 'Other', value: 'other' },
  ]

  const handleBalanceChange = (e) => {
    if (e.target.value === 'other') {
      setData({ ...data, credits_requested: e.target.value })
      setCustomBalanceInput(true)
    } else {
      setData({ ...data, credits_requested: e.target.value })
      setCustomBalanceInput(false)
    }
  }

  const handleCustomBalanceChange = (e) => {
    setCustomBalance({ ...data, credits_requested: e.target.value })
  }

  const handleBalanceRequest = () => {
    showPageLoader()
    post(
      '/communication/credits/purchase',
      data.credits_requested === 'other' ? customBalance : data,
    ).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        handleClose()
        showSuccess('Balance Requested Successfully')
      } else {
        showFailure(res.response.error)
      }
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    handleBalanceRequest()
  }
  return (
    <form
      style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
      onSubmit={handleSubmit}
    >
      <PixelFlexBox>
        <DcDropDown
          value={data.credits_requested}
          onChange={handleBalanceChange}
          placeholder="Balance Options*"
          required
          options={balanceOptions}
        />
        {customBalanceInput && (
          <DcInput
            value={customBalance.credits_requested}
            onChange={handleCustomBalanceChange}
            placeholder="Custom Balance*"
            required
          />
        )}
      </PixelFlexBox>
      <PixelFlexBox justifyContent="flex-end" gap="10px" width="100%">
        <DcButton
          type="submit"
          variant="primary"
          disabled={
            data.credits_requested === '' ||
            (data.credits_requested === 'other' &&
              customBalance.credits_requested === '')
          }
        >
          Request Balance
        </DcButton>
        <DcButton
          type="button"
          variant="outline-secondary"
          onClick={() => {
            setAddBalanceModal(false)
          }}
        >
          Cancel
        </DcButton>
      </PixelFlexBox>
    </form>
  )
}
export default AddBalance
